import { createContext } from 'react';

const ModalContext = createContext(void 0);

ModalContext.displayName = 'context(Modal)';

export default ModalContext;